module.exports = __webpack_public_path__ + "static/img/yichu2.8033a3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/yichu2.png
// module id = Bfuk
// module chunks = 24